function GalleryArrowIcon(props)
{
    return(<svg className={props.class} viewBox="0 0 20 20">
  <path d="M10,20A10,10,0,1,0,0,10,10,10,0,0,0,10,20ZM8.711,4.3l5.7,5.766L8.7,15.711,7.3,14.289l4.289-4.242L7.289,5.7Z"/>
</svg>)
}

export default GalleryArrowIcon